var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStats1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 560.9 313.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n        isolation: isolate;\n        opacity: .2;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: url(#linear-gradient);\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 1.4px;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 167.9,
    y1: -36.9,
    x2: 391.8,
    y2: 350.8,
    gradientTransform: "translate(0 313.7) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7427e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#de4681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#c7548a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a16a99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6c89ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#29b0c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08c4d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 168.3,
    y1: -36.3,
    x2: 391.4,
    y2: 350.2,
    gradientTransform: "translate(0 313.7) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7427e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#de4681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#c7548a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a16a99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6c89ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#29b0c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08c4d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 162.6,
    y1: -47.4,
    x2: 398.8,
    y2: 361.7,
    gradientTransform: "translate(0 313.7) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d5182e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cc1f34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#b53248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8f5267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5a7e92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#17b6c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08c4d6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M516.5,277.8H43.2c-7.8-7.8-12.2-12.2-20-20V55.7l20-20h473.3c7.8,7.8,12.2,12.2,20,20v202.1c-7.8,7.8-12.2,12.2-20,20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M516.5,277.8H43.2c-7.8-7.8-12.2-12.2-20-20V55.7l20-20h473.3c7.8,7.8,12.2,12.2,20,20v202.1c-7.8,7.8-12.2,12.2-20,20Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.9,285.7H32l-16.5-17.3v-110.9l1.4,2v108.3l15.7,16.5h68.3l1,1.4h0ZM253.7,27.8H32l-16.5,17.3v43.2l1.4,1.4v-44l15.7-16.5h219.8l1.4-1.4h0ZM448.2,27.4h-17l-1.4,1.4h17l1.4-1.4ZM419.2,27.4h-17l-1.4,1.4h17l1.4-1.4ZM389,27.4h-17l-1.4,1.4h17l1.4-1.4ZM358.3,27.4h-17l-1.4,1.4h17l1.4-1.4ZM479.1,27.4h-15.5l-1.4,1.4h15.5l1.4-1.4ZM529.4,27.4h-35l-1.4,1.4h35.8l15.7,16.5v222.2l-15.7,16.5H245.3l1.4,1.4h282.7l16.5-17.3V44.7l-16.5-17.3h0ZM16.5,145c-.8,0-1.5.7-1.5,1.5s.6,1.5,1.5,1.5,1.4-.7,1.4-1.5-.7-1.5-1.4-1.5ZM16.5,135.2c-.8,0-1.5.7-1.5,1.5s.6,1.5,1.5,1.5,1.4-.7,1.4-1.5-.7-1.5-1.4-1.5ZM16.5,127.5c-.8,0-1.5.7-1.5,1.5s.6,1.5,1.5,1.5,1.4-.7,1.4-1.5-.7-1.5-1.4-1.5ZM219.1,284.6c0-.8-.6-1.5-1.4-1.5s-1.4.7-1.4,1.5.6,1.5,1.4,1.5,1.4-.7,1.4-1.5ZM228.5,284.6c0-.8-.6-1.5-1.4-1.5s-1.4.7-1.4,1.5.6,1.5,1.4,1.5,1.4-.7,1.4-1.5ZM235.8,284.6c0-.8-.6-1.5-1.4-1.5s-1.4.7-1.4,1.5.6,1.5,1.4,1.5,1.4-.7,1.4-1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats1);
export default __webpack_public_path__ + "static/media/stats 1.ca69833d0242a0f1244722a180496b7e.svg";
export { ForwardRef as ReactComponent };